<template>
  <el-pagination background layout="prev, pager, next" :page-size="pageSize" v-model:currentPage="currentPage" :pager-count="5" :small="store.state.base.responsive.isSM" :total="originalList.length" @current-change="changePage"></el-pagination>
</template>

<script lang="ts">
import { defineComponent, watch, onMounted, ref, computed } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from '@/store/index'

export default defineComponent({
  props: {
    pagedList: {
      type: Array,
      'default': () => ([]),
    },
    originalList: {
      type: Array,
      'default': () => ([]),
    },
    pageSize: {
      type: Number,
      'default': () => (10),
    },
  },
  emits: ['update:pagedList'],
  setup(props, context) {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const currentPage = ref(1)

    const toPagedList = computed(() => {
      return props.originalList.slice(props.pageSize * currentPage.value - props.pageSize, props.pageSize * currentPage.value)
    })

    const changePage = (page: number) => {
      const pageQuery = { p: page }
      currentPage.value = page
      context.emit('update:pagedList', toPagedList.value)
      router.push({ path: route.path, query: { ...route.query, ...pageQuery } })
    }

    const setCurrentPage = () => {
      const page = route.query.p ? Number(route.query.p) : 1
      currentPage.value = page
    }

    onMounted(() => {
      setCurrentPage()
      context.emit('update:pagedList', toPagedList.value)
    })

    watch(() => props.originalList, () => {
      setCurrentPage()
      context.emit('update:pagedList', toPagedList.value)
    })

    return {
      store,
      changePage,
      currentPage
    }
  },
})
</script>
